import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Box, Typography } from "@mui/material";
import logo from "../../assets/images/logo.png";

const Header = () => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box display="flex" sx={{ cursor: "pointer" }}>
        <Typography variant="h5">Hi Rider,</Typography>
        {/* <ArrowDropDownIcon /> */}
      </Box>
      <img src={logo} alt="logo" height="50" />
    </Box>
  );
};

export default Header;
